<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/storeList'}">校区管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{isEdit?'编辑校区':'添加校区'}}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{isEdit?'编辑校区':'添加校区'}}</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="校区名称" prop="name">
                        <el-input placeholder="不超过50个字符" maxlength="50" v-model="fromData.storeName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
          <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
          <el-button @click="resetForm('fromData')">取消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{
          storeName: '',
          id:''
        },
        isEdit: false,
        rules: {
          storeName:[
            { required: true, message: '请输入校区名称', trigger: 'blur' }
          ],
        }
      };
    },
    created() {
        this.initData();
    },
    methods: {
      async addStore() {
        let url = this.isEdit?'/ea/student/store/edit':"/ea/student/store/add"
        const { data: res } = await this.$http.post(url,this.fromData);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success(this.isEdit?"编辑校区成功":"新增校区成功");
        this.$router.push({
            path: '/storeList',
        })
      },
      initData() {
          let that = this
          let params = this.$route.params;
          if(params && params.type=='edit'){
              this.fromData = params.recordDate
              this.isEdit = true;
          }else{
            this.fromData.type = 2
          }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addStore();
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$router.push("/storeList");
      }
  },
};
</script>

<style lang="less" scoped>
  /deep/ .el-upload__input{
    display: none;
  }
  .wran_tips {
      color: red;
      font-weight: 400;
  }
</style>
